import { render, staticRenderFns } from "./yearReportVersionDetails.vue?vue&type=template&id=dca41da0&"
import script from "./yearReportVersionDetails.vue?vue&type=script&lang=js&"
export * from "./yearReportVersionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports